import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_3/sub2_3_2/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_3_2_bg from '../../assets/images/s2_3_2_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_3_2() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_3_2_bg}
        mainTitle="청소를 쉽고 깔끔하게"
        productName="CREAMBOT"
        productModel="C40"
        description="3중 롤러 건습분리 세척 후 초고속 건조
스마트 청소로봇
"
        theme="dark"
      />
      <Content />
      <Footer />
    </>
  );
}
